import { createFileRoute } from '@tanstack/react-router';
import { MakePayment } from '@/components/MakePayment';

export const Route = createFileRoute('/_protected/make-payment')({
  component: MakePayment,
});
